module.exports = __webpack_public_path__ + "img/icon4.866640a4.png";